import { render, staticRenderFns } from "./photoshop.vue?vue&type=template&id=3707631d&scoped=true&"
import script from "./photoshop.vue?vue&type=script&lang=js&"
export * from "./photoshop.vue?vue&type=script&lang=js&"
import style1 from "./photoshop.vue?vue&type=style&index=1&id=3707631d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3707631d",
  null
  
)

export default component.exports